module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "maillist"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.mails), function(mail, index) {
    return _c('div', {
      key: index,
      staticClass: "mails"
    }, [_c('mail-item', {
      attrs: {
        "read": mail.read,
        "num": mail.num,
        "sender": mail.sender,
        "title": mail.title,
        "time": mail.time,
        "size": mail.size,
        "linker": _vm.mailLinker(mail)
      }
    })], 1)
  })), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "columns is-mobile pagination"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isFirstPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isFirstPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("上页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v(_vm._s((_vm.currentPage + "/" + _vm.totalPage)))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isLastPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("下页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isLastPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.totalPage)
      }
    }
  }, [_vm._v("末页")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81178eaa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mail/MailList.vue
// module id = 251
// module chunks = 1